import { render } from "./GradesTable.vue?vue&type=template&id=66375ba0&bindings={\"grades\":\"props\",\"arraySum\":\"options\"}"
import script from "./GradesTable.vue?vue&type=script&lang=ts"
export * from "./GradesTable.vue?vue&type=script&lang=ts"

import "./GradesTable.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script